import {
    NEXT_TOUR,
    PREV_TOUR,
    TOURS_GET,
    TOURS_GET_REQUEST,
    TOURS_GET_SUCCESS,
    FEATURED_TOURS_GET,
    FEATURED_TOURS_GET_REQUEST,
    FEATURED_TOURS_GET_SUCCESS,
    DESTINATION_GET_REQUEST,
    DESTINATION_GET_SUCCESS,
    DESTINATION_GET_FAILURE,
    DESTINATIONS_GET_REQUEST,
    DESTINATIONS_GET_SUCCESS,
    DESTINATIONS_GET_FAILURE,
    PROMO_GET_SUCCESS,
    PROMO_GET_FAILURE,
    PROMO_GET_REQUEST,
    LANDMARK_GET_REQUEST,
    LANDMARK_GET_SUCCESS,
    LANDMARK_GET_FAILURE,
    LANDMARKS_GET_REQUEST,
    LANDMARKS_GET_SUCCESS,
    LANDMARKS_GET_FAILURE,
    HOTELS_GET_REQUEST,
    HOTELS_GET_SUCCESS,
    HOTELS_GET_FAILURE,
    ACTIVITIES_GET,
    ACTIVITIES_GET_SUCCESS,
    TYPES_GET_SUCCESS,
    SELECT_TOUR,
    SELECT_MAP_TOUR,
    GALLERY_GET,
    GALLERY_GET_SUCCESS,
    GALLERY_GET_REQUEST,
    SERVICE_GALLERY_GET_REQUEST,
    SERVICE_GALLERY_GET_SUCCESS,
    SELECT_PHOTO,
    TOUR_GET,
    TOUR_GET_REQUEST,
    TOUR_GET_SUCCESS,
    TOUR_GET_FAILURE,
    SET_CENTER,
    SET_ZOOM,
    PREV_DAY,
    NEXT_DAY,
    SELECT_DAY,
    TOGGLE_DAY,
    HOVER_DAY,
    TOGGLE_CATEGORIES,
    TOGGLE_DEPARTURE,
    SELECT_DEPARTURE,
    SET_MAP_HEIGHT,
    SET_MAP,
    SET_MAP_CONFIG,
    SELECT_DESTINATION,
    SELECT_MAIN_DESTINATION,
    SELECT_ACTIVITY,
    SELECT_MONTH,
    SELECT_TYPE,
    SELECT_MAIN_TYPE,
    SELECT_SEASON,
    SELECT_LANDMARK,
    POINTS_GET,
    POINTS_GET_SUCCESS,
    POINTS_GET_FAILURE,
    POINTS_GET_REQUEST,
    SET_DAY_PHOTO_VISIBLE,
    SET_ROUTE_DRAW,
    SELECT_MAP_PHOTO,
    NEXT_MAP_PHOTO,
    PREV_MAP_PHOTO,
    ACTIVATE_MAP,
    FIXED_MAP,
    SET_BOUNDED_OBJECTS,
    MORE_OBJECTS,
    PAGE_GET_SUCCESS,
    PAGE_GET_REQUEST,
    PAGE_GET_FAILURE,
    SELECT_PAGE,
    SET_SCROLL,
    TOURS_SEARCH_REQUEST,
    TOURS_SEARCH_SUCCESS,
    TOURS_SEARCH_FAILURE,
    TOURS_SEARCH_BY_MODE,
    TOURS_SEARCH_BY_MODE_SUCCESS,
    TOURS_SEARCH_BY_MODE_REQUEST,
    TOURS_SEARCH_BY_MODE_FAILURE,
    LOCATIONS_GET_SUCCESS,
    SET_LOCATION,
    TOUR_MENU_GET,
    TOUR_MENU_GET_SUCCESS,
    TOUR_MENU_GET_REQUEST,
    TOGGLE_VIEW_PHOTO,
    SELECT_TAB,
    SET_MAP_FILTER,
    TOGGLE_MAP_FILTER,
    HOTEL_GET,
    HOTEL_GET_REQUEST,
    HOTEL_GET_SUCCESS,
    HOTEL_GET_FAILURE,
    REVIEWS_GET_REQUEST,
    REVIEWS_GET_SUCCESS,
    REVIEWS_GET_FAILURE,
    ALL_REVIEWS_GET_FAILURE,
    ALL_REVIEWS_GET_REQUEST,
    ALL_REVIEWS_GET_SUCCESS,
    CLOSE_DEPARTURE_TOOLTIP,
    OPEN_REVIEW,
    OPEN_REVIEW_ANSWER,
    TOGGLE_REVIEW_RATE,
    OPEN_REVIEWS,
    SELECT_REVIEWS_LANG,
    PLAY_VIDEO,
    SWIPE_GALLERY,
    TOGGLE_DESCRIPTION,
    CLEAR_ROUTE
} from '../actions/tours';



const initialState = {
    list: [],
    destination: {},
    mainDestination: {},
    departure: {},
    landmark: {},
    landmarks: {list: []},
    hotels: {list: []},
    destinations: [],
    types: [],
    tourMenu: [],
    locations: [],
    mapFilterParams: {},
    type: {},
    hotel: {},
    mainType: {},
    activity: {},
    menuTours: [],
    activities: [],
    promo: {},
    isFetching: false,
    activeTour: 0,
    tour: {},
    season: {},
    showToursPhotos: true,
    map:  {
        center: {lat: 67.47523802443854, lng: 106.01531982421375},
        zoom: 3,
        active: false,
        fixed: false,
        show_photos: true,
        show_landmarks: true,
        show_tours: true,
        showBoundedObjects: false,
        type: 'ROADMAP'
    },
    showCategories: false,
    showMapFilter: false,
    mapHeight: '100vh',
    points: {
        list: [],
        isFetching: false,
        status: {}
    },
    fetchCounter: 0,
    successCounter: 0,
    gallery: {list: [], activePhoto: 0},
    route: {markers: []},
    boundedObjects: {
        tours: {list: []},
        landmarks: {list: [], count: 3},
        photos: {list: [], count: 5}
    },
    page: {},
    scroll: {opacity:1, scrollY: 0},
    loader: {count: 0},
    selectedTab: 0,
    reviews: []
};

export default function tours(state = initialState, action) {
    let tour = {}, newState = {};
    let mapConfig;
    let newConfig;
    let filter;
    let list;
    let photos;
    let photoIndex;
    let newPhoto;
    let loader;
    let toursArray;
    let filterMode;
    let menuTours;
    let destinationInList;
    let activeTour;
    let mapTours = [];
    let points = [];
    let reviews = [];

    switch (action.type) {
        case TOURS_GET:
        case TOURS_GET_REQUEST:
            loader = Object.assign({}, state.loader);
            loader.count++;
            return {...state};
        case TOURS_GET_SUCCESS:
            toursArray = [];
            loader = Object.assign({}, state.loader);
            loader.count--;

           //console.log(action.req.headers['x-pagination-total-count']);

            points = state.points.list;
            points.forEach(function(point){
                point.tours.forEach(function(mapTour){
                    mapTour.hidden = false;
                });
            });

            if(action.req && action.req.data && action.req.data.length){
                toursArray = action.req.data;



                return {...state, list: toursArray, activeTour: 0, points: {...state.points, list: points}, toursCount: action.req.headers['x-pagination-total-count']};
            } else {
                return state;
            }
        case FEATURED_TOURS_GET_REQUEST:
            loader = Object.assign({}, state.loader);
            loader.count++;
            return {...state, loader: loader};
        case FEATURED_TOURS_GET_SUCCESS:
            toursArray = [];
            loader = Object.assign({}, state.loader);
            loader.count--;


            points = state.points.list;
            points.forEach(function(point){
                point.tours.forEach(function(mapTour){
                    mapTour.hidden = false;
                });
            });

            if(action.req && action.req.data){
                toursArray = action.req.data;



                return {...state, list: toursArray, activeTour: 0, menuTours: toursArray, loader: loader, points: {...state.points, list: points}};
            } else {
                return state;
            }
        case TOURS_SEARCH_REQUEST:
            loader = Object.assign({}, state.loader);
            loader.count++;

            return {...state, loader: loader};
        case TOURS_SEARCH_FAILURE:
            loader = Object.assign({}, state.loader);
            loader.count--;

            return {...state, loader: loader};
        case TOURS_SEARCH_SUCCESS:
            loader = Object.assign({}, state.loader);
            loader.count--;
            toursArray = [];
            points = state.points.list;
            points.forEach(function(point){
                point.tours.forEach(function(mapTour){
                    mapTour.hidden = true;
                });
            });
            if(action.req && action.req.data && action.req.data.length){
                action.req.data.forEach(function(item){
                    toursArray.push(item.tour ? item.tour : item);
                });
            }


            toursArray.forEach(function(item){
                points.forEach(function(point){
                    point.tours.forEach(function(mapTour){
                        if ((mapTour && item) && (mapTour.id == item.id)) {
                            mapTour.hidden = false;
                        }
                    });
                });
            });

            return {...state, list: toursArray, destination: {...state.destination, tours: toursArray}, loader: loader, boundedObjects: state.boundedObjects};

        case TOURS_SEARCH_BY_MODE_SUCCESS:
            loader = Object.assign({}, state.loader);
            loader.count--;
            menuTours = [];
            if(action.req && action.req.data && action.req.data.length){

                action.req.data.forEach(function(tour){
                    destinationInList = false;
                    if (tour.destinations && state.mainDestination.id) {
                        tour.destinations.forEach(function(destination){
                            if (destination.id == state.mainDestination.id) {
                                destinationInList = true;
                            }
                        });
                    }

                    if ((!state.mainType.id || state.mainType.id == tour.type ) && (!state.mainDestination.id || destinationInList)) {
                        menuTours.push(tour);
                    }
                });




                return {...state, list: action.req.data, activeTour: 0, menuTours: menuTours, loader: loader
                };
            } else {
                return {...state, loader: loader};
            }
        case TOURS_SEARCH_BY_MODE_REQUEST:
            loader = Object.assign({}, state.loader);
            loader.count++;
            return {...state, filterMode: action.payload, loader: loader};
        case TOUR_MENU_GET_SUCCESS:
            return {...state, tourMenu: action.req.data};
        case DESTINATIONS_GET_REQUEST:
            loader = Object.assign({}, state.loader);
            loader.count++;
            return {...state, loader : loader};
        case DESTINATIONS_GET_FAILURE:
            loader = Object.assign({}, state.loader);
            loader.count--;
            return {...state, loader : loader};
        case DESTINATIONS_GET_SUCCESS:
            loader = Object.assign({}, state.loader);
            loader.count--;
            let destinationsArray = [];
            if(action.req && action.req.data && action.req.data.length){
                destinationsArray = action.req.data;

                destinationsArray.sort(function (a, b) {
                    if (a.title > b.title) {
                        return 1;
                    }
                    if (a.title < b.title) {
                        return -1;
                    }
                    return 0;
                });

                return {...state, destinations: destinationsArray, loader : loader
                };
            } else {
                return state;
            }
        case LOCATIONS_GET_SUCCESS:
            return {...state, locations : action.req.data};
        case SET_LOCATION:
            let locations = state.locations;
            locations.forEach(function(location){
                if (location.id == action.payload.id) {
                    Object.assign(location, action.payload);
                }
            });

            return {...state, locations : locations};
        case TYPES_GET_SUCCESS:
            let types = [
                {id: 'active'},
                {id: 'discovery'},
                {id: 'pure'},
                {id: 'cruise'},
                {id: 'expedition'}
            ];

            action.req.data.forEach(function(loadedType){
                types.forEach(function(type){
                    if (type.id == loadedType.id) {
                        Object.assign(type, loadedType);
                    }
                });
            });


            return {...state, types : types};
        case ACTIVITIES_GET_SUCCESS:
           //console.info('ACTIVITIES');
           //console.info(action);
            return {...state, activities : action.req.data};
        case NEXT_TOUR:
            if (state.activeTour < state.menuTours.length-1) {
                return {...state, activeTour: state.activeTour+1}
            } else {
                return {...state, activeTour: 0}
            }
        case PREV_TOUR:
            if (state.activeTour > 0) {
                return {...state, activeTour: state.activeTour-1}
            } else {
                return {...state, activeTour: state.menuTours.length-1}
            }
        case SELECT_DAY:
            return {...state, tour: {...state.tour, activeDay: action.payload}};
        case TOGGLE_DAY:
            let days = state.tour.programDays;
            return {...state, tour: {...state.tour, programDays: days.map((day, i) => {
                if (i == action.payload) {
                    day.active = !day.active;
                }
                return day;
            })}};
        case SET_DAY_PHOTO_VISIBLE:
            return {...state, tour: {...state.tour, viewDayPhoto: action.payload}};
        case HOVER_DAY:
            return {...state, tour: {...state.tour, hoverDay: action.payload}};
        case NEXT_DAY:
            if (state.tour.activeDay < state.tour.programDays.length-1) {
                return {...state, tour: {...state.tour, activeDay: state.tour.activeDay+1}}
            } else {
                return {...state, tour: {...state.tour, activeDay: 0}}
            }
        case PREV_DAY:
            if (state.tour.activeDay > 0) {
                return {...state, tour: {...state.tour, activeDay: state.tour.activeDay-1}}
            } else {
                return {...state, tour: {...state.tour, activeDay: state.tour.programDays.length-1}}
            }
        case SELECT_TOUR:
            tour = action.payload;
            tour.loaded = false;
            newState = {...state,
                tour: tour, gallery: {list: [], activePhoto: 0}, selectedTab: 0
            };




            if (tour.map_config) {
                newConfig = Object.assign({}, state.map, {zoom: tour.map_config.zoom, center: {lat: tour.map_config.center.latitude, lng: tour.map_config.center.longitude}});
            } else {
                newConfig = state.map;
            }
            return {...newState, map: newConfig};
        case SELECT_MAP_TOUR:
            tour = action.payload;
            tour.loaded = false;
            newState = {...state,
                tour: tour, gallery: {list: [], activePhoto: 0}, selectedTab: 0
            };




            if (tour.map_config) {
                newConfig = Object.assign({}, state.map, {zoom: tour.map_config.zoom, center: {lat: tour.map_config.center.latitude, lng: tour.map_config.center.longitude}, route: {polylines: [], markers: []}});
            } else {
                newConfig = {...state.map, route: {polylines: [], markers: []}};
            }
            return {...newState, map: newConfig};
        case CLEAR_ROUTE:
            newConfig = {...state.map, route: {polylines: [], markers: []}};
            return {...state, map: newConfig};
        case ACTIVATE_MAP:
            return {...state, map: {...state.map, active: action.payload}};
        case FIXED_MAP:
            return {...state, map: {...state.map, fixed: action.payload}};
        case SELECT_DESTINATION:
            let fullDestination = null;

            if (action.payload) {
                state.destinations.forEach(function(destination){
                    if (destination.id == action.payload.id) {
                        fullDestination = destination;
                        return false;
                    }
                });
            }

            if (action.payload) {
                if (action.payload.map_config && action.payload.map_config.zoom && action.payload.point) {
                    newConfig = Object.assign({}, state.map, {zoom: action.payload.map_config.zoom, center: {lat: action.payload.point.latitude, lng: action.payload.point.longitude}});
                } else {
                    newConfig = Object.assign({}, state.map);
                }

            } else {
                newConfig = Object.assign({}, state.map);
            }
            if (action.payload && action.payload.id) {
                filter = Object.assign( state.mapFilterParams, {d: action.payload.id});
            } else {
                filter = Object.assign({}, state.mapFilterParams);
                delete filter.d;
            }

            return {...state, destination : (fullDestination)?fullDestination:{}, map: newConfig, mapFilterParams: filter};
        case SELECT_MAIN_DESTINATION:
            filterMode = state.filterMode;
            if (!action.payload.id && state.mainType.id) {
                filterMode = 't';
            } else if (action.payload.id && !state.mainType.id) {
                filterMode = 'd';
            } else if (!action.payload.id && !state.mainType.id) {
                filterMode = undefined;
            }

            menuTours = state.menuTours;
            if (filterMode == 't') {
                menuTours = [];
                state.list.forEach(function(tour){
                    destinationInList = false;
                    if (action.payload.id) {
                        tour.destinations.forEach(function(destination){
                            if (destination.id == action.payload.id) {
                                destinationInList = true;
                            }
                        });
                    }

                    if ((!state.mainType.id || state.mainType.id == tour.type ) && (!action.payload.id || destinationInList)) {
                        menuTours.push(tour);
                    }
                });

            }

           //console.log(filterMode);
            return {...state, mainDestination : action.payload, activeTour: (filterMode != 'd')?0:state.activeTour, filterMode: filterMode, menuTours: menuTours};
        case SELECT_TYPE:

            if (action.payload.id) {
                filter = Object.assign(state.mapFilterParams, {t: action.payload.id});
            } else {
                filter = Object.assign({}, state.mapFilterParams);
                delete filter.t;
            }

            return {...state, type : (action.payload)?action.payload:{}, mapFilterParams: filter};
        case OPEN_REVIEW:
            reviews = state.reviews;
            return {...state, reviews: reviews.map((review, i) => {
                if (i == action.payload) {
                    review.open = true;
                }
                return review;
            }), openedReviews: state.openedReviews};
        case OPEN_REVIEW_ANSWER:
            reviews = state.reviews;
            return {...state, reviews: reviews.map((review, i) => {
                if (i == action.payload) {
                    review.openAnswer = true;
                }
                return review;
            }), openedReviews: state.openedReviews};
        case TOGGLE_REVIEW_RATE:
            reviews = state.reviews;
            return {...state, reviews: reviews.map((review, i) => {
                if (i == action.payload) {
                    review.openRate = !review.openRate;
                }
                return review;
            }), openedReviews: state.openedReviews};
        case OPEN_REVIEWS:
            reviews = state.reviews;
            let showedReviewsCount = 0;
            reviews.forEach(function(review, i){
                if (review.show) {
                    showedReviewsCount = i+1;
                    return false;
                }
            });
            reviews.forEach(function(review, i){
                if (i < showedReviewsCount + 5) {
                    review.show = true;
                } else {
                    return false;
                }
            });

            return {...state, reviews: reviews, openedReviews: showedReviewsCount + 5};
        case SELECT_MAIN_TYPE:
            filterMode = state.filterMode;

            if (!action.payload.id && state.mainDestination.id) {
                filterMode = 'd';
            } else if (action.payload.id && !state.mainDestination.id) {
                filterMode = 't';
            } else if (!action.payload.id && !state.mainDestination.id) {
                filterMode = undefined;
            }


           //console.log(filterMode);
            menuTours = state.menuTours;
            if (filterMode == 'd') {
                menuTours = [];
                state.list.forEach(function(tour){
                    destinationInList = false;
                    if (state.mainDestination.id) {
                        tour.destinations.forEach(function(destination){
                            if (destination.id == state.mainDestination.id) {
                                destinationInList = true;
                            }
                        });
                    }

                    if ((!action.payload.id || action.payload.id == tour.type ) && (!state.mainDestination.id || destinationInList)) {
                        menuTours.push(tour);
                    }
                });

            }


            return {...state, mainType : action.payload, activeTour: (filterMode != 't')?0:state.activeTour, filterMode: filterMode, menuTours: menuTours};
        case SELECT_SEASON:

            if (typeof action.payload.id) {
                filter = Object.assign(state.mapFilterParams, {m: action.payload.months});
            } else {
                filter = Object.assign(state.mapFilterParams, {});
                delete filter.m;
            }

            return {...state, season : action.payload, mapFilterParams: filter};
        case SELECT_ACTIVITY:
            if (action.payload.id) {
                filter = Object.assign(state.mapFilterParams, {a: action.payload.id});
            } else {
                filter = Object.assign({}, state.mapFilterParams);
                delete filter.a;
            }
            return {...state, activity : action.payload, mapFilterParams: filter};
        case SELECT_MONTH:
            if (action.payload) {
                filter = Object.assign(state.mapFilterParams, {m: action.payload});
            } else {
                filter = Object.assign({}, state.mapFilterParams);
                delete filter.m;
            }
            return {...state, month : action.payload, mapFilterParams: filter};
        case SELECT_LANDMARK:
            return {...state, landmark : action.payload};
        case TOUR_GET_REQUEST:
            loader = Object.assign({}, state.loader);
            loader.count++;
            return {...state, loader : loader, isFetching: true, getArchivedTour: action.payload.isArchived};
        case TOUR_GET_SUCCESS:
            let tour = {};
            loader = Object.assign({}, state.loader);
            loader.count--;
            if(action.req && action.req.data){
                tour = action.req.data;
                tour.loaded = true;
                newState = {...state,
                    tour: tour
                };
                let route = {polylines: [], markers: []};
                tour.programDays.forEach(function(day){
                    if(day.route && day.route.polylines) {
                        day.route.polylines.forEach(function(polyline){
                            route.polylines.push(polyline);
                        });
                    }
                    if(day.route && day.route.points) {
                        day.route.points.forEach(function(point){
                            route.markers.push(point);
                        });
                    }
                });
                route.draw = false;



                newConfig = Object.assign({}, state.map, {zoom: tour.map_config.zoom, center: {lat: tour.map_config.center.latitude, lng: tour.map_config.center.longitude}, route: route});

                return {...newState, map: newConfig, loader : loader, isFetching: false, redirectId: (action.payload == tour.id_old)?tour.id:'', isArchived: tour.is_archived};
            } else {
                return {...state, loader : loader, isFetching: false};
            }
        case TOUR_GET_FAILURE:
            loader = Object.assign({}, state.loader);
            loader.count--;
            return {...state, loader :loader, failedFetch: true};
        case GALLERY_GET:
            return {...state,
                gallery: {...state.gallery, id: action.payload}
            };
        case GALLERY_GET_REQUEST:
            return {...state,
                gallery: {...state.gallery, id: action.payload, isFetching: true}
            };
        case GALLERY_GET_SUCCESS:
            let gallery  = {};
            if(action.req && action.req.data){
                gallery = action.req.data;

                return {...state,
                    gallery: {...state.gallery, list: gallery, isFetching: false}
                };
            } else {
                return state;
            }
        case REVIEWS_GET_REQUEST:
            loader = Object.assign({}, state.loader);
            loader.count++;
            return {...state, fetchReviews: true,
                reviewsLang: action.lang,
                loader: loader,
            };
        case REVIEWS_GET_FAILURE:
            loader = Object.assign({}, state.loader);
            loader.count--;
            return {...state, fetchReviews: false,  loader: loader,};
        case ALL_REVIEWS_GET_REQUEST:
            loader = Object.assign({}, state.loader);
            loader.count++;
            return {...state, fetchReviews: true,
                reviewsLang: action.lang,
                loader: loader
            };
        case ALL_REVIEWS_GET_FAILURE:
            loader = Object.assign({}, state.loader);
            loader.count--;
            return {...state, fetchReviews: false, loader: loader,};
        case REVIEWS_GET_SUCCESS:
            loader = Object.assign({}, state.loader);
            loader.count--;
            if (parseInt(action.req.headers['x-pagination-current-page']) == 1) {
                reviews = action.req.data;
            } else {
                reviews = state.reviews;
                action.req.data.forEach(function(review){
                    reviews.push(review);
                });
            }


            return {...state,
                reviews: reviews,
                openedReviews: parseInt(action.req.headers['x-pagination-current-page']),
                fetchReviews: false,
                loader: loader,
                reviewsPageCount: parseInt(action.req.headers['x-pagination-page-count'])
            };

        case ALL_REVIEWS_GET_SUCCESS:
            loader = Object.assign({}, state.loader);
            loader.count--;
            if (parseInt(action.req.headers['x-pagination-current-page']) == 1) {
                reviews = action.req.data;
            } else {
                reviews = state.reviews;
                action.req.data.forEach(function(review){
                    reviews.push(review);
                });
            }

            return {...state, reviews: reviews, loader: loader, openedReviews: parseInt(action.req.headers['x-pagination-current-page']), fetchReviews: false, reviewsPageCount: parseInt(action.req.headers['x-pagination-page-count'])};

        case SERVICE_GALLERY_GET_SUCCESS:
            if(action.req && action.req.data){
                let updatedTour = state.tour;



                return {...state, tour: {...state.tour, programDays: state.tour.programDays.map((day, dayIndex) => {
                    if (dayIndex == action.payload.index) {

                            var editDay = {};

                            Object.assign(editDay, day);

                            editDay.programServices.map((service, serviceIndex) => {
                                if (serviceIndex == action.payload.serviceIndex) {
                                    var updatedService = service;
                                    updatedService.serviceItem.gallery = action.req.data;

                                    return updatedService;
                                } else {
                                    return service
                                }
                            });
                        return editDay;
                    } else {
                        return day;
                    }
                })}};
            } else {
                return state;
            }
        case SELECT_PHOTO:
            return {...state,
                gallery: {...state.gallery, activePhoto: action.payload, delta: 0, list: state.gallery.list.map((photo, i)=>{
                    photo.play = false;
                    return photo;
                })}
            };
        case SWIPE_GALLERY:
            return {...state,
                gallery: {...state.gallery, delta: action.payload}
            };
        case PLAY_VIDEO:
            return {...state,
                gallery: {...state.gallery, activePhoto: action.payload, list: state.gallery.list.map((photo, i)=>{
                    if (action.payload == i) {
                        photo.play = !photo.play;
                    } else {
                        photo.play = false;
                    }
                    return photo;
                })}
            };
        case TOGGLE_DEPARTURE:
            let departures = state.tour.departures;
            departures.forEach(function(departure){
                if (departure.start_at == action.payload.start_at) {
                    departure.opened = !departure.opened;
                }

            });
            return {...state, tour: {...state.tour, departures: departures}};

        case SELECT_DEPARTURE:
            return {...state, departure: action.payload};

        case SELECT_MAP_PHOTO:

            return {...state,
                photo: action.payload.photo,
                mapPhotoIndex: action.payload.index
            };
        case NEXT_MAP_PHOTO:
             photos = state.boundedObjects.photos.list;
             photoIndex = state.mapPhotoIndex;

             newPhoto = {};
            if (photoIndex+1 < photos.length) {
                photoIndex++;
                newPhoto = Object.assign({}, photos[photoIndex]);
                newPhoto.next = photos[photoIndex+1]?photos[photoIndex+1]:photos[0];
                newPhoto.prev = photos[photoIndex];
            } else {
                photoIndex = 0;
                newPhoto = Object.assign({}, photos[photoIndex]);
                newPhoto.next = photos[1];
                newPhoto.prev = photos[photoIndex];
            }

           //console.log(photos);

           //console.log(newPhoto);
           //console.log(photoIndex);

            return {...state, photo: newPhoto, mapPhotoIndex: photoIndex};
        case PREV_MAP_PHOTO:
            photos = state.boundedObjects.photos.list;
            photoIndex = state.mapPhotoIndex;

           //console.log(photos.length);

            newPhoto = {};
            if (photoIndex-1 >= 0) {
                photoIndex--;
                newPhoto = Object.assign({}, photos[photoIndex]);
                newPhoto.prev = photos[photoIndex-1]?photos[photoIndex-1]:photos[photos.length-1];
            } else {
                photoIndex = photos.length-1;
                newPhoto = Object.assign({}, photos[photoIndex]);
                newPhoto.prev = photos[photos.length-2];
            }

           //console.log(photos);

           //console.log(newPhoto);
           //console.log(photoIndex);

            return {...state, photo: newPhoto, mapPhotoIndex: photoIndex};
        case DESTINATION_GET_REQUEST:
            loader = Object.assign({}, state.loader);
            loader.count++;
            return {...state, loader : loader};
        case DESTINATION_GET_FAILURE:
            loader = Object.assign({}, state.loader);
            loader.count--;
            return {...state, loader : loader, failedFetch: true};
        case DESTINATION_GET_SUCCESS:
            loader = Object.assign({}, state.loader);
            loader.count--;
            let destination = {};
            if(action.req && action.req.data){
                destination = action.req.data;

                newConfig = Object.assign({}, state.map, {zoom: destination.map_config.zoom, center: {lat: destination.point.latitude, lng: destination.point.longitude}});

                return {...state,
                    destination: destination,
                    map: newConfig,
                    loader : loader
                };
            } else {
                return state;
            }
        case PROMO_GET_REQUEST:
            loader = Object.assign({}, state.loader);
            loader.count++;
            return {...state, loader : loader};
        case PROMO_GET_FAILURE:
            loader = Object.assign({}, state.loader);
            loader.count--;
            return {...state, loader : loader, failedFetch: true};
        case PROMO_GET_SUCCESS:
            loader = Object.assign({}, state.loader);
            loader.count--;
            let promo = {};
            if(action.req && action.req.data){
                promo = action.req.data;

                newConfig = Object.assign({}, state.map, {zoom: promo.config.map.zoom, center: {lat: promo.config.map.latitude, lng: promo.config.map.longitude}});

                return {...state,
                    promo: action.req.data,
                    loader : loader
                };
            } else {
                return state;
            }
        case LANDMARK_GET_SUCCESS:
            return {...state, landmark: action.req.data};
        case LANDMARKS_GET_SUCCESS:
            return {...state, landmarks: {...state.landmarks, list: action.req.data, pageCount: parseInt(action.req.headers['x-pagination-page-count'])}};
        case HOTELS_GET_SUCCESS:
            return {...state, hotels: {...state.hotels, list: action.req.data, pageCount: parseInt(action.req.headers['x-pagination-page-count'])}};
        case LANDMARK_GET_FAILURE:
            return {...state, failedFetch: true};
        case HOTEL_GET_SUCCESS:
            return {...state, hotel: action.req.data};
        case HOTEL_GET_FAILURE:
            return {...state, failedFetch: true};
        case SELECT_PAGE:
            return {...state, page: {...state.page, slug: action.payload}};
        case PAGE_GET_REQUEST:

            loader = Object.assign({}, state.loader);
            loader.count++;

            return {...state, page: {...state.page, slug: action.payload}, loader: loader};
        case PAGE_GET_SUCCESS:
            loader = Object.assign({}, state.loader);
            loader.count--;
            return {...state, page: action.req.data, loader: loader};
        case PAGE_GET_FAILURE:
            loader = Object.assign({}, state.loader);
            loader.count--;
            return {...state, loader: loader, failedFetch: true};
        case POINTS_GET_REQUEST:
            loader = Object.assign({}, state.loader);
            //loader.count++;
           //console.log('LOADER');
           //console.log(loader);
            return {...state, points: {...state.points, isFetching: true}, loader : loader};
        case POINTS_GET_FAILURE:
            loader = Object.assign({}, state.loader);
            //loader.count--;
           //console.log('LOADER');
           //console.log(loader);
            return {...state, loader : loader};
        case POINTS_GET_SUCCESS:
            loader = Object.assign({}, state.loader);
            //loader.count--;
           //console.log('LOADER');
           //console.log(loader);
            if(action.req && action.req.data){
                let headers = {page_count: parseInt(action.req.headers['x-pagination-page-count']), page: parseInt(action.req.headers['x-pagination-current-page'])};
                let location = action.req.data[0].location_id;
                if (!state.points.status[location] || (state.points.status[location].page < headers.page)) {

                    list = state.points.list;
                    toursArray = state.list;
                   //console.info('LIST')
                   //console.info(state.points)
                    if (!list) {
                        list = [];
                    }


                    let paramsLength = 0;

                    for (let key in state.mapFilterParams) {
                        if (state.mapFilterParams[key]) paramsLength++;
                    }

                        action.req.data.forEach(function(item){
                            list.push(item);

                            if (paramsLength) {
                                item.tours.forEach(function(mapTour){
                                    mapTour.hidden = true;
                                    toursArray.forEach(function(tour){
                                        if (mapTour.id == tour.id) {
                                            mapTour.hidden = false;
                                        }
                                    });
                                });

                            }
                        });





                }

                let status = state.points.status;
                status[location] = headers;


                return {...state, points: {...state.points, list: list, headers: headers, isFetching: false, status: status}, loader : loader}
            } else {
                return {...state, loader : loader};
            }
        case SET_BOUNDED_OBJECTS:


            return {...state, boundedObjects: action.payload};
        case MORE_OBJECTS:
            let objects = Object.assign({}, state.boundedObjects);
            let object = Object.assign({}, state.boundedObjects[action.payload.type], {count: state.boundedObjects[action.payload.type].count + action.payload.count});
            objects[action.payload.type] = object;

            return {...state, boundedObjects: objects};
        case SET_CENTER:
            return {...state, map: {...state.map, center: action.payload}};
        case SET_ZOOM:
            return {...state, map: {...state.map, zoom: action.payload}};
        case TOGGLE_CATEGORIES:
            return {...state, showCategories: !state.showCategories};
        case TOGGLE_DESCRIPTION:
            return {...state, tour: {...state.tour, showDescription: !state.tour.showDescription}};
        case TOGGLE_MAP_FILTER:
            return {...state, showMapFilter: !state.showMapFilter};
        case TOGGLE_VIEW_PHOTO:
            return {...state, showToursPhotos: !state.showToursPhotos};
        case SET_MAP_HEIGHT:
            return {...state, mapHeight: action.payload};
        case SET_MAP:
           //console.info('MAP!!!');
            return {...state, mapObject: action.payload};
        case SET_MAP_CONFIG:
           //console.info('MAP!!!');


            mapConfig = action.payload;

            newConfig = Object.assign({}, state.map, mapConfig);

            return {...state, map: newConfig, mapHeight: 1};
        case SET_MAP_FILTER:
            return {...state, mapFilterParams: action.payload};
        case SET_ROUTE_DRAW:
            return {...state, map: {...state.map, route: {...state.map.route, draw: action.payload}}};
        case SET_SCROLL:
            return {...state, scroll: action.payload};
        case SELECT_TAB:
            return {...state, selectedTab: !action.payload.stopIndication?action.payload.index:state.selectedTab, tour: {...state.tour, indicateButton: (action.payload.stopIndication?false:true)}};
        case CLOSE_DEPARTURE_TOOLTIP:
            return {...state, tour: {...state.tour, showDeparturesTooltip: false}};
        default:
            return state;
    }


}


// WEBPACK FOOTER //
// ./src/common/reducers/tours.js